import React, { useState } from "react";
import styles from "./styles.module.scss";
import DashboardSearchResults from "../DashboardSearchResults";
import DashboardFilterAndSearch from "../DashboardFilterAndSearch";

interface DashboardSearchProps {
  userIsJustAnInstaller: boolean;
  setSelectedTab: (tab: string) => void;
  selectedTab: string;
}

const DashboardSearch = ({
  userIsJustAnInstaller,
  setSelectedTab,
  selectedTab,
}: DashboardSearchProps) => {
  // Search
  const [searchValue, setSearchValue] = useState("");

  return (
    <div className={styles.dashboard_search}>
      <div className={styles.search_title}>Search</div>
      <DashboardFilterAndSearch
        selectedTab={selectedTab}
        searchValue={searchValue}
        setSelectedTab={setSelectedTab}
        setSearchValue={setSearchValue}
        userIsJustAnInstaller={userIsJustAnInstaller}
      />

      <DashboardSearchResults
        selectedTab={selectedTab}
        searchValue={searchValue}
      />
    </div>
  );
};

export default DashboardSearch;
